export const PRODUCT_NOT_FOUND_ERROR = 'PRODUCT_NOT_FOUND_ERROR'
export const ALIAS_MISMATCH_ERROR = 'ALIAS_MISMATCH_ERROR'
